import { registerSvgImageMap } from "@/shared/charts";

const FACILITY_SCHEMATIC_MAP_NAME = "facility-schematic";

/** Uses one replaceable ECharts map slot for the currently selected deployment. */
export function getFacilitySchematicMapName(): string {
  return FACILITY_SCHEMATIC_MAP_NAME;
}

/**
 * Replaces the selected deployment's floor plan raster image in the shared
 * geo-map slot, keeping scatter coordinates in the same pixel space as its
 * world-to-pixel transform's target frame.
 *
 * `imageUrl` is provided by `useFacilitySchematicAssets` (a cache-first object
 * URL for the floor plan image), so this is called from an effect once that
 * asset has loaded rather than eagerly at module scope.
 */
export function registerFacilitySchematicMap(
  imageUrl: string,
  imageSize: { width: number; height: number }
): void {
  registerSvgImageMap({
    mapName: getFacilitySchematicMapName(),
    imageUrl,
    imageWidth: imageSize.width,
    imageHeight: imageSize.height,
  });
}
